import CreatedPage from './CreatedPage';

export default CreatedPage;